import { __extends, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkSecondaryButton } from './uitk-secondary-button.esm.js';
import { UitkButton } from './uitk-button.esm.js';

var UitkFloatingButton = /** @class */ (function (_super) {
    __extends(UitkFloatingButton, _super);
    function UitkFloatingButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkFloatingButton.prototype.render = function () {
        var props = this.props;
        var cssClassNames = classNames("".concat(UitkButton.baseClassName, "-floating"), props.className);
        return React.createElement(UitkSecondaryButton, __assign({}, props, { className: cssClassNames }));
    };
    UitkFloatingButton.displayName = 'UitkFloatingButton';
    return UitkFloatingButton;
}(React.Component));

export { UitkFloatingButton };
